import './assets/main.styl'

import * as Sentry from '@sentry/vue'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'

import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

import Clipboard from 'v-clipboard3'

import {
  formatDateTime,
  formatNumberDate,
  formatStorePointType,
  formatAccountBookType,
  formatProjectType,
  formatProjectPassType,
  formatProjectSportsPlayType,
  formatProjectNumberPlayType,
  formatProjectCancelType,
  formatProjectState,
  formatGrouponState,
  formatGrouponProjectState,
  formatStoreMemberRole,
  formatNumberPoolMoney,
  formatWeekday,
  formatSportsSpf,
  formatSportsRqspf,
  formatSportsBf,
  formatSportsZjq,
  formatSportsBqc,
  formatSportsRfsf,
  formatSportsDxf,
  formatSportsSf,
  formatSportsSfc,
  formatBdSfgg,
  formatBdSxds,
  formatNumberBit,
  formatSettlementState,
  formatSettlementMethod,
  formatRequestErrorCode,
} from '@/utils/format'

import {
  setLocalStorage,
  getQueryParams,
  updateAccountInformation,
  updateStoreInformation,
  isCooperation,
  isFromStore,
  isToStore,
  isProjectViewed,
  reverseArray,
  getBonusPermutation,
  isNumberComplex,
  compareSportsMatch,
  getMatchDate,
  getIssueEndTime,
  checkSingleMatch,
  checkJczqCount,
  checkJclqCount,
  getCombinations,
  getBonusCombinations,
  getScalarProductSum,
  uniqueArray,
  isGtLimitMoney,
  isBalanceEnough,
} from '@/utils/common'

import { initJSONPInterceptor } from '@/utils/yidun'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://6cda02151e3f8dd12157c6ec6d6c9ff2@o90808.ingest.us.sentry.io/4508806534463488',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

app.config.globalProperties.$sentry = Sentry

app.config.globalProperties.$formatDateTime = formatDateTime
app.config.globalProperties.$formatNumberDate = formatNumberDate
app.config.globalProperties.$formatStorePointType = formatStorePointType
app.config.globalProperties.$formatAccountBookType = formatAccountBookType
app.config.globalProperties.$formatProjectType = formatProjectType
app.config.globalProperties.$formatProjectPassType = formatProjectPassType
app.config.globalProperties.$formatProjectSportsPlayType = formatProjectSportsPlayType
app.config.globalProperties.$formatProjectNumberPlayType = formatProjectNumberPlayType
app.config.globalProperties.$formatProjectCancelType = formatProjectCancelType
app.config.globalProperties.$formatProjectState = formatProjectState
app.config.globalProperties.$formatGrouponState = formatGrouponState
app.config.globalProperties.$formatGrouponProjectState = formatGrouponProjectState
app.config.globalProperties.$formatStoreMemberRole = formatStoreMemberRole
app.config.globalProperties.$formatNumberPoolMoney = formatNumberPoolMoney
app.config.globalProperties.$formatWeekday = formatWeekday
app.config.globalProperties.$formatSportsSpf = formatSportsSpf
app.config.globalProperties.$formatSportsRqspf = formatSportsRqspf
app.config.globalProperties.$formatSportsBf = formatSportsBf
app.config.globalProperties.$formatSportsZjq = formatSportsZjq
app.config.globalProperties.$formatSportsBqc = formatSportsBqc
app.config.globalProperties.$formatSportsRfsf = formatSportsRfsf
app.config.globalProperties.$formatSportsDxf = formatSportsDxf
app.config.globalProperties.$formatSportsSf = formatSportsSf
app.config.globalProperties.$formatSportsSfc = formatSportsSfc
app.config.globalProperties.$formatBdSfgg = formatBdSfgg
app.config.globalProperties.$formatBdSxds = formatBdSxds
app.config.globalProperties.$formatNumberBit = formatNumberBit
app.config.globalProperties.$formatSettlementState = formatSettlementState
app.config.globalProperties.$formatSettlementMethod = formatSettlementMethod
app.config.globalProperties.$formatRequestErrorCode = formatRequestErrorCode

app.config.globalProperties.$setLocalStorage = setLocalStorage
app.config.globalProperties.$getQueryParams = getQueryParams
app.config.globalProperties.$updateAccountInformation = updateAccountInformation
app.config.globalProperties.$updateStoreInformation = updateStoreInformation
app.config.globalProperties.$isCooperation = isCooperation
app.config.globalProperties.$isFromStore = isFromStore
app.config.globalProperties.$isToStore = isToStore
app.config.globalProperties.$isProjectViewed = isProjectViewed
app.config.globalProperties.$reverseArray = reverseArray
app.config.globalProperties.$getBonusPermutation = getBonusPermutation
app.config.globalProperties.$isNumberComplex = isNumberComplex
app.config.globalProperties.$compareSportsMatch = compareSportsMatch
app.config.globalProperties.$getMatchDate = getMatchDate
app.config.globalProperties.$getIssueEndTime = getIssueEndTime
app.config.globalProperties.$checkSingleMatch = checkSingleMatch
app.config.globalProperties.$checkJczqCount = checkJczqCount
app.config.globalProperties.$checkJclqCount = checkJclqCount
app.config.globalProperties.$getCombinations = getCombinations
app.config.globalProperties.$getBonusCombinations = getBonusCombinations
app.config.globalProperties.$getScalarProductSum = getScalarProductSum
app.config.globalProperties.$uniqueArray = uniqueArray
app.config.globalProperties.$isGtLimitMoney = isGtLimitMoney
app.config.globalProperties.$isBalanceEnough = isBalanceEnough

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(Clipboard)

initJSONPInterceptor()

// import vConsole from 'vconsole'

// new vConsole()

app.mount('#app')
